export default __webpack_public_path__ + "static/media/secure.adff4ca7.svg";